/**
 * A single, non-modifiable instance of an empty object.
 */
export var emptyObject = Object.freeze({});